// Set Facebook App ID depending on whether user is on production or staging
if (window.location.href.indexOf("breakdownthebeast-stg") > -1) {
  var versionId = '1690802461043027';
} else {
  var versionId = '333039807433658';
};

// Facebook SDK
window.fbAsyncInit = function() {
  FB.init({
    appId            : versionId,
    autoLogAppEvents : true,
    xfbml            : true,
    version          : 'v3.1'
  });
};

(function(d, s, id){
  var js, fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) {return;}
  js = d.createElement(s); js.id = id;
  js.src = "https://connect.facebook.net/en_US/sdk.js";
  fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));

// Share to appropriate link when button is clicked
window.onload = function() {

  // Facebook
  var facebookButtons = document.getElementsByClassName('js-facebook-share');
  for (var i = 0; i < facebookButtons.length; i++) {
    facebookButtons[i].addEventListener('click', function() {
      FB.ui({
        method: 'share',
        href: 'http://breakdownthebeast.com',
      }, function(response){});
    });
  }

  // Twitter
  var twitterButtons = document.getElementsByClassName('js-twitter-share');
  for (var i = 0; i < twitterButtons.length; i++) {
    twitterButtons[i].addEventListener('click', function() {
      window.open(
        'https://twitter.com/intent/tweet?url=http://breakdownthebeast.com&text=Our%20monster%20plastic%20problem%20is%20growing%20by%20the%20minute.%20It%27s%20time%20to%20break%20down%20the%20beast%20with%20HP.',
        '_blank',
        'width=730, height=448'
      );
    });
  }

}
